import { render, staticRenderFns } from "./dialog-resendfiledetail.vue?vue&type=template&id=c627f5d6&"
import script from "./dialog-resendfiledetail.vue?vue&type=script&lang=js&"
export * from "./dialog-resendfiledetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports